import $ from 'jquery'
import image from "@/assets/company_logo.png"

export default {
    name: 'creer-societe',
    components: {},
    props: [],
    data() {
        return {
            societe: {
                nom: "",
                debut_contrat: "",
                telephone: "",
                phone: "",
                email: "",
                adresse: "",
                fin_contrat: "",
                secteur_activite: "",
                type_contrat: "",
                certification: "",
                preview_logo: image,
                image_logo: "",
                fichier_contrat: "",

            },

            loading: false,
            btn_diable: false,
            types_contrat: [],
            certifications: [],
            secteurs: [],
            files: [],
            file_error: false,
            import_loading: false,

            // Tel input placeholder config
            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
			country_code: ''

        }
    },
    computed: {

    },
    mounted() {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        // recupération des certifications
        this.$store.dispatch('getCertifications').then(
            (response) => this.certifications = response
        );

        // recupération des types contrats
        this.$store.dispatch('getTypesContrats').then(
            (response) => this.types_contrat = response
        );

        // recupération des secteurs
        this.$store.dispatch('getSecteurs').then(
            (response) => this.secteurs = response
        );
    },
    methods: {
        handleFilesUpload() {

            let uploadedFiles = this.$refs.files.files;
            /*
              Adds the uploaded file to the files array
            */
            this.files = []

            for (var i = 0; i < uploadedFiles.length; i++) {
                this.files.push(uploadedFiles[i]);
            }
            this.societe.fichier_contrat= this.files[0];

            this.file_error = false

        },

        previewImage: function(event) {
            var input = event.target;

            if (input.files) {
                var reader = new FileReader();
                reader.onload = (e) => {
                    this.societe.preview_logo = e.target.result;
                }
                this.societe.image_logo = input.files[0];
                reader.readAsDataURL(input.files[0]);
            }
        },

        selectLogo: function() {
            this.$refs.my_file.click();
        },

        /**
         * Clear Error message
         */
        clearError()
        {
            this.tel_is_required = false
        },

        countryChanged(country) {
            this.country_code = '+' + country.dialCode
        },

        async onSubmit() {
            this.loading = true
            this.btn_diable = true

            const isValid = await this.$refs.form.validate();

            if (!isValid) {
                this.loading = false
                this.btn_diable = false
                return;
            }

            // Check if Phone number is given
            // if (this.societe.phone == '') {
            //     this.tel_is_required = true
            //     return;
            // }
            if (this.societe.phone != '') {
                this.societe.telephone = this.country_code+' '+this.societe.phone
            } else {
                this.societe.telephone = ''
            }
            

            // if (!success || this.files.length == 0) {
            //     this.file_error = true
            //     return;
            // }

            //control the dates
            let date_debut = (this.societe.debut_contrat != '')?this.dateFormatToSend(this.societe.debut_contrat):''
            let date_fin = (this.societe.fin_contrat != '')?this.dateFormatToSend(this.societe.fin_contrat):''

            if (date_fin.date < date_debut.date) {
                this.doErrorMsg("La date de debut doit précéder la date de fin de contrat")
                return;
            }

            // Send the datas
            

            // format the data to send
            //1-certifications
            let certifications = [];
            if (this.societe.certification) {
                this.societe.certification.forEach(element => {
                    certifications.push(element.id)
                });
            }

            this.societe.certification = certifications;
            this.societe.type_contrat = (this.societe.type_contrat.id)?this.societe.type_contrat.id:'';
            this.societe.debut_contrat = (this.societe.debut_contrat != '')?date_debut.date_to_send:''
            this.societe.fin_contrat = (this.societe.fin_contrat != '')?date_fin.date_to_send:''

            console.log("S: ", this.societe)

            //sending
            let form_data = new FormData();
            for (let key in this.societe) {
                form_data.append(key, this.societe[key])
            }

            this.$store.dispatch("saveSociete", form_data).then(() => {
                
                // après le rendu sur la page, faire disparaitre le modal
                this.doSuccessMsg("La societé a été créée avec succès");
                
                this.loading = false
                this.btn_diable = false
                this.$router.push('/societes')
            }, error => {
                this.loading = false;
                this.societe.certification = ""

                if (error.response.data.errors) {
                    let errors = error.response.data.errors;
                    let msg_a_inclure = "";

                    // console.log("erreur", errors)
                    if (errors.phone)
                        msg_a_inclure += "<li>- Ce numero de téléphone a déja été pris </li>"

                    if (errors.email)
                        msg_a_inclure += "<li>- Cet email a déja été utilisé </li>"

                    let msg_a_afficher = '<ul>' + msg_a_inclure + '</ul>';
                    // console.log('msg_a_afficher', msg_a_afficher)
                    this.doErrorMsg(msg_a_afficher)

                } else {
                    this.doErrorMsg("Erreur d'enregistrement")
                }

            });
        },
     
        doSuccessMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },

        dateFormatToSend: function(given_date) {
            let date = new Date(given_date)
            let month = date.getMonth() + 1,
                day = date.getDate();

            if (month < 10) month = '0' + month
            let date_to_send = `${date.getFullYear()}-${month}-${day}
                                        `;
            return { date: date, date_to_send: date_to_send }
        }
    }
}
